import { render, staticRenderFns } from "./ModConsxContratxCuenta.vue?vue&type=template&id=88c363aa"
import script from "./ModConsxContratxCuenta.vue?vue&type=script&lang=js"
export * from "./ModConsxContratxCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports